import { hubfulRpcClient } from '../../../utils/API';
import { getActiveHubTrialsByHubIdRpc } from 'trials-service-types';
import { dataFetchingErrorHandler } from '../../../errors/dataFetchingErrorHandler';
export const getActiveHubTrials = () => hubfulRpcClient.call(getActiveHubTrialsByHubIdRpc, {}).catch(dataFetchingErrorHandler.withDefaultResult('Failed to fetch active hub trials', []));